import { useEffect } from 'react'
import * as React from 'react'

/* Helpers */
import { HashClaim, Transaction, TransactionStatus } from '../../api'
import { layer2Links } from '../../lib/constants'

/* Components */
import ClaimFooterMessage from './ClaimFooterMessage'
import { LinkButton } from 'components/LinkButton'

/* Assets */
import Spinner from 'images/etherscan-spinner.svg'

/*
 * @dev: Component to show user that transactions is being mined
 * */
const ClaimPending: React.FC<{
  claim: HashClaim
  findTransaction: (hash: string) => Promise<Transaction | undefined>
}> = ({ claim, findTransaction }) => {
  const checkLoop = async () => {
    const transaction = await findTransaction(claim.qr_hash)
    if (
      !transaction ||
      transaction.status === TransactionStatus.WAITING_TX ||
      transaction.status === TransactionStatus.PENDING
    ) {
      setTimeout(checkLoop, 5000)
    }
  }
  useEffect(() => {
    checkLoop()
  }, []) /* eslint-disable-line react-hooks/exhaustive-deps */

  return (
    <div className={'claim-info'} data-aos="fade-up" data-aos-delay="300">
      <div className={'info-title'}>This POAP is being added to your collection</div>
      <div className={'info-tx info-pending'}>
        <img src={Spinner} alt={'Mining'} />
        Pending
      </div>
      {claim.tx_hash && (
        <>
          <div className={'text-info'}>Please wait a few seconds, or follow the transaction on the block explorer</div>
          <LinkButton
            text={'View Transaction'}
            link={layer2Links.tx(claim.tx_hash)}
            extraClass={'link-btn'}
            target={'_blank'}
          />
        </>
      )}
      <ClaimFooterMessage />
    </div>
  )
}

export default ClaimPending
